import { render, staticRenderFns } from "./MAM_rateInfo.vue?vue&type=template&id=541b1904&scoped=true&"
import script from "./MAM_rateInfo.vue?vue&type=script&lang=js&"
export * from "./MAM_rateInfo.vue?vue&type=script&lang=js&"
import style0 from "./MAM_rateInfo.vue?vue&type=style&index=0&id=541b1904&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541b1904",
  null
  
)

export default component.exports